export const useUniversalUrl = () => {
	const nuxtApp = useNuxtApp();
	return nuxtApp?.ssrContext?.event?.node?.req?.url
		? `http://${nuxtApp?.ssrContext?.event.node.req.headers.host}${nuxtApp?.ssrContext?.event.node.req.url}`
		: window.location.href;
};
